import { useEffect, useState } from "react";
import TopBar from "@/components/TopBar";
import TrustSignalsMarquee from "@/components/landing/TrustSignalsMarquee";
import TimelineHistoria from "@/components/landing/TimelineHistoria";
import SimuladorGanancias from "@/components/landing/SimuladorGanancias";
import ProductoInsignia from "@/components/landing/ProductoInsignia";
import HeroSection from "@/components/landing/sections/HeroSection";
import LocationsSection from "@/components/landing/sections/LocationsSection";
import IndicatorsSection from "@/components/landing/sections/IndicatorsSection";
import ExpansionNoteSection from "@/components/landing/sections/ExpansionNoteSection";
import WhyRubiSection from "@/components/landing/sections/WhyRubiSection";
import ComparisonSection from "@/components/landing/sections/ComparisonSection";
import ProjectsSection from "@/components/landing/sections/ProjectsSection";
import HowItWorksSection from "@/components/landing/sections/HowItWorksSection";
import HumanizationSection from "@/components/landing/sections/HumanizationSection";
import CapitalAllocationSection from "@/components/landing/sections/CapitalAllocationSection";
import InvestorJourneySection from "@/components/landing/sections/InvestorJourneySection";
import CaseStudiesSection from "@/components/landing/sections/CaseStudiesSection";
import MobileAppSection from "@/components/landing/sections/MobileAppSection";
import GallerySection from "@/components/landing/sections/GallerySection";
import FoundersSection from "@/components/landing/sections/FoundersSection";
import FAQSection from "@/components/landing/sections/FAQSection";
import CTAFinalSection from "@/components/landing/sections/CTAFinalSection";
import Footer from "@/components/landing/sections/Footer";
import StickyCTA from "@/components/landing/sections/StickyCTA";
import api from "@/lib/api";
import useSeo from "@/hooks/useSeo";
import JsonLd, { organizationSchema, faqSchema, websiteSchema } from "@/components/JsonLd";

export default function Landing() {
  useSeo({ title: "Invierte en la expansión de Rubí Perfumería · Proyecto Diamante", description: "Participa desde $250,000 MXN en proyectos seleccionados de nuevas aperturas de Rubí Perfumería: 39 sucursales, 17 estados, utilidades mensuales y contrato AEP. Conoce el Proyecto Diamante.", path: "/" });
  const [content, setContent] = useState({});
  const [metrics, setMetrics] = useState(null);
  const [showSticky, setShowSticky] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const [c, m] = await Promise.all([api.get("/public/content"), api.get("/public/metrics")]);
        setContent(c.data);
        setMetrics(m.data);
      } catch (_e) { /* noop */ }
    })();
  }, []);

  useEffect(() => {
    const onScroll = () => setShowSticky(window.scrollY > 800);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hiddenSet = new Set(content.layout?.hidden || []);
  const isHidden = (key) => hiddenSet.has(key);

  return (
    <div className="min-h-screen bg-[#FAFAFA] text-[#0A0A0A] overflow-x-clip">
      <JsonLd id="org" data={organizationSchema(content.brand)} />
      <JsonLd id="website" data={websiteSchema()} />
      <JsonLd id="faq" data={faqSchema(content.faq?.items)} />
      <TopBar variant="public" />

      <HeroSection
        hero={content.hero}
        heroStats={content.hero_stats}
        roundConfig={content.round_config}
        metrics={metrics}
      />

      {!isHidden("indicators") && <IndicatorsSection block={content.indicators} locations={content.locations_map} />}
      {!isHidden("trust_marquee") && <TrustSignalsMarquee block={content.trust_signals} />}
      {!isHidden("locations_map") && <LocationsSection block={content.locations_map} />}
      {!isHidden("expansion_note") && <ExpansionNoteSection block={content.expansion_note} />}
      {!isHidden("timeline") && <TimelineHistoria block={content.timeline} />}
      {!isHidden("why_rubi") && <WhyRubiSection block={content.why_rubi} locations={content.locations_map} />}
      {!isHidden("comparison") && <ComparisonSection block={content.comparison} locations={content.locations_map} simulator={content.simulator} />}
      {!isHidden("simulator") && <SimuladorGanancias block={content.simulator} />}
      {!isHidden("projects") && <ProjectsSection block={content.projects} metrics={metrics} />}
      {!isHidden("how_it_works") && <HowItWorksSection block={content.how_it_works} />}
      {!isHidden("capital_allocation") && <CapitalAllocationSection block={content.capital_allocation} />}
      {!isHidden("investor_journey") && <InvestorJourneySection block={content.investor_journey} />}
      {!isHidden("producto_insignia") && <ProductoInsignia block={content.producto_insignia} about={content.about} />}
      {!isHidden("humanization") && <HumanizationSection block={content.humanization} />}
      {!isHidden("case_studies") && <CaseStudiesSection block={content.case_studies} />}
      {!isHidden("mobile_app") && <MobileAppSection block={content.mobile_app} />}
      {!isHidden("gallery") && <GallerySection block={content.gallery} />}
      {!isHidden("founders") && <FoundersSection block={content.founders} />}
      {!isHidden("faq") && <FAQSection block={content.faq} />}
      {!isHidden("cta_final") && <CTAFinalSection block={content.cta_final} brand={content.brand} />}

      <Footer brand={content.brand} />
      <StickyCTA show={showSticky} />
    </div>
  );
}
